export function getFooterLiterals(t: any) {
  return {
    title: t("footer.title"),
    showPrivacyPolicyText: t("footer.showPrivacyPolicyText"),
    showLegalConditionsText: t("footer.showLegalConditionsText"),
    showCookiePolicyText: t("footer.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText:
      "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}
export function getPageLiterals(t: any) {
  return {
    title: t("literalsResumen.title"),
    addPaymentCard: t("literalsResumen.addPaymentCard"),
    aboutPayment: t("literalsResumen.aboutPayment"),
    tcTitle: t("literalsResumen.tcTitle"),
    tcAccept: t("literalsResumen.tcAccept"),
    seeMoreInfo: t("literalsResumen.seeMoreInfo"),
    totalTravel: t("literalsResumen.totalTravel"),
    back: t("literalsResumen.back"),
    pay: t("literalsResumen.pay"),
    part1:t("literalsResumen.part1"),
    part2:t("literalsResumen.part2"),
    part3:t("literalsResumen.part3"),
    part4:t("literalsResumen.part4"),
    policyError:t("literalsResumen.policyError"),
    addDiscountCode: t("literalsResumen.addDiscountCode"),
    desgloseModal: {
      title: t("literalsResumen.desgloseModal.title"),
      altCloseModal: t("literalsResumen.desgloseModal.altCloseModal"),
      totalActivity: t("literalsResumen.desgloseModal.totalActivity"),
      adult: t("literalsResumen.desgloseModal.adult"),
      kid: t("literalsResumen.desgloseModal.kid"),
      senior: t("literalsResumen.desgloseModal.senior"),
      children: t("literalsResumen.desgloseModal.children"),
      passenger: t("literalsResumen.desgloseModal.passenger"),
      discount: t("literalsResumen.desgloseModal.discount"),
    },
    promoCode: {
      title: t("literalsResumen.promoCode.title"),
      desc1: t("literalsResumen.promoCode.desc1"),
      desc2: t("literalsResumen.promoCode.desc2"),
      desc3: t("literalsResumen.promoCode.desc3"),
      desc4: t("literalsResumen.promoCode.desc4"),
      inputTitle: t("literalsResumen.promoCode.inputTitle"),
      button: t("literalsResumen.promoCode.button"),
      error: t("literalsResumen.promoCode.error"),
      applyDiscount: t("literalsResumen.promoCode.applyDiscount"),
      discountsAvailable:{
        title: t("promoCode.discountsAvailable.title"), 
        card: {
             eurDiscount:t("promoCode.discountsAvailable.card.eurDiscount"),
             validityDate:t("promoCode.discountsAvailable.card.validityDate"),
             points:t("promoCode.discountsAvailable.card.points"),
         },
         toast: {
             title: t("promoCode.discountsAvailable.toast.title"),
             subtitle: t("promoCode.discountsAvailable.toast.subtitle"),
         }
       }
    },
  };
}
export function getPrivatePolicyLiterals(t: any) {
  return {
    titleComments: t("titleComments"),
    Movitaxi: {
      title: t("moviTaxiTitle"),
      urlMovitaxiTCs: t("urlMovitaxiTCs"),
      urlMovitaxiPoliPri: t("urlMovitaxiPoliPri"),
    },
    Reby: {
      title: t("rebyTitle"),
      urlRebyTCs: t("urlRebyTCs"),
      urlRebyPoliPri: t("urlRebyPoliPri"),
    },
    Cooltra: {
      title: t("cooltraTitle"),
      urlCooltraTCs: t("urlCooltraTCs"),
      urlCooltraPoliPri: t("urlCooltraPoliPri"),
    },
    Karhoo: {
      title: t("karhooTitle"),
      urlKarhooTCs: t("urlKarhooTCs"),
      urlKarhooPoliPri: t("urlKarhooPoliPri"),
    },
    Renfe: {
      title: t("renfeTitle"),
      urlRenfeCondViajero: t("urlRenfeCondViajero"),
      urlRenfeCondVenta: t("urlRenfeCondVenta"),
      urlRenfePoliPri: t("urlRenfePoliPri"),
      urlRenfeInfLegal: t("urlRenfeInfLegal"),
    },

    Bolt: {
      title: t("boltTitle"),
      urlBoltTCs: t("urlBoltTCs"),
      urlBoltPoliPri: t("urlBoltPoliPri"),
    },
    terCond: t("terCond"),
    poliPriv: t("poliPriv"),
    condicGenViaje: t("condicGenViaje"),
    condicGenVenta: t("condicGenVenta"),
    infoLegal: t("infoLegal"),
    descMessage: t("descMessage"),
    title: t("title"),
    buttonCancelar: t("buttonCancelar"),
    buttonAccept: t("buttonAccept"),
  };
}

export function getUserHasDebtsModalLiterals(t: any) {
  return {
    title: t("getUserHasDebtsModalLiterals.title"),
    desc: t("getUserHasDebtsModalLiterals.desc"),
    confirmButton: t("getUserHasDebtsModalLiterals.confirmButton"),
  };
}
export function getUpdatedTarifModalLiterals(t: any) {
  return {
    title: t("getTarifUpdatedModalLiterals.title"),
    desc: t("getTarifUpdatedModalLiterals.desc"),
    okbutton: t("getTarifUpdatedModalLiterals.confirmButton"),
  };
}

export function getCheckTimeoutTaxiLiterals(t: any) {
  return {
    title: t("getCheckTimeoutTaxiLiterals.title"),
    desc: t("getCheckTimeoutTaxiLiterals.desc"),
    confirmButton: t("getCheckTimeoutTaxiLiterals.confirmButton"),
  };
}

export function getErrorPayModalLiterals(t: any) {
  return {
    title: t("getErrorPayModalLiterals.title"),
    desc: t("getErrorPayModalLiterals.desc"),
    okButton: t("getErrorPayModalLiterals.okButton")
  };
}

export function getOrderFaildLiterals(t: any,t3:any) {
  return {
    title: t3("getErrorPayModalLiterals.title"),
    desc: t("literals.errorOrderFail"),
    okButton: t3("getErrorPayModalLiterals.okButton")
  };
}

export function getPaymentMethodModalLiterals(t: any) {
    return {
      title: t("getPaymentMethodModalLiterals.title"),
      subtitle: t("getPaymentMethodModalLiterals.subtitle"),
      cancelButton: t("getPaymentMethodModalLiterals.cancelButton"),
      addButton: t("getPaymentMethodModalLiterals.addButton"),
      expirationWarningText: t("getPaymentMethodModalLiterals.expirationWarningText"),
    };
  }
  
export function orderTicketsByPrice(a: any, b: any) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}

export function addAproxText(text: string, t: any): string {
  return text.includes("prox") ? text : `${t("approx")} ${text}`;
}

export function getMessageExpiredModal(t: any) {
    return {
      title: t("getMessageExpiredModal.title"),
      description : t("getMessageExpiredModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text:  t("getMessageExpiredModal.buttons.0.text"),
        }
      ]
    }
  }

  export function getChangePaymentMethod(t: any) {
    return {
        stateCard: t("getChangePaymentMethod.stateCard")
    }
  }